export const enum SectionId {
	CLIENT_OVERVIEW = 1,
	CLIENT_ANALITYC = 2,
	CLIENT_EVENTS = 3,
	CLIENT_AML = 4,
	CLIENT_WEBSITES = 5,
	CLIENT_FILES = 6,
	CLIENT_INFO = 7,
	CLIENT_SETTINGS = 8,
	CLIENT_USERS = 9,
	CLIENT_SESSIONS = 10,
	CLIENT_PROFILE = 11,
	CLIENT_SERVICES_VALIDATION = 12,
	CLIENT_MONITORING = 13,
	CLIENT_AUDIT_LOG = 14,
	CLIENT_CHARGEBACKS = 15,
	CLIENT_ACCOUNTANT = 16,
}
